import { defineMessages } from 'react-intl';

export default defineMessages({
  giftCard: {
    id: 'shop.cart.giftCard',
    defaultMessage: 'Gift Card',
  },
  applyCoupon: {
    id: 'shop.cart.couponApply',
    defaultMessage: 'Redeem',
  },
  removeCoupon: {
    id: 'shop.cart.couponRemove',
    defaultMessage: 'Remove',
  },
  showGiftCardForm: {
    id: 'shop.cart.showGiftCardForm',
    defaultMessage: 'Add a gift card',
  },
  giftCardUpdated: {
    id: 'shop.cart.giftCardUpdated',
    defaultMessage: 'Your gift card has been applied successfully.',
  },
});
